<template>
  <div class="expenses-groups">
    <template v-if="!branchNotFound">
      <v-list v-if="expensesGroups.length > 0" two-line>
        <v-list-item-group>
          <template v-for="(expensesGroup, index) in expensesGroups">
            <v-list-item
              :key="expensesGroup.id"
              :to="{name: 'expenses-group', params: { groupId: expensesGroup.id } }"
            >
              <v-list-item-content>
                <v-list-item-title class="headline" v-text="expensesGroup.name"></v-list-item-title>
                <v-list-item-subtitle class="text--primary" v-text="expensesGroup.description"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text v-text="expensesGroup.created"></v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="index + 1 < expensesGroups.length" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>

      <v-container v-else>
        <v-row justify="center">
          <v-col cols="auto">
            <div class="grey--text body-1">No Expenses Groups. Add Expenses Group(s)</div>
          </v-col>
        </v-row>
      </v-container>

      <v-fab-transition>
        <v-btn
          v-show="isSmaller"
          dark
          color="primary darken-4"
          fixed
          bottom
          right
          fab
          @click="openNewExpensesGroupDialog()"
        >
          <v-icon large>mdi-select-group</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>

    <v-container v-else>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card color="white" class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-icon size="150">mdi-cancel</v-icon>
            </div>

            <div class="text-center title grey--text">
              <span class="font-weight-black">Branch</span> not available
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ExpensesGroups",

  data: () => ({}),

  components: {},

  methods: {
    openNewExpensesGroupDialog() {
      this.$store.commit("setNewExpensesGroupDialog", true);
    },

    async getExpensesGroups() {
      var branchId = this.$route.params.branchId;

      await this.$store.dispatch("getExpensesGroups", branchId);
    }
  },

  watch: {
    $route() {
      this.getExpensesGroups();
    }
  },

  mounted() {
    this.getExpensesGroups();
  },

  computed: {
    branchNotFound() {
      return this.$store.state.branches.branchNotFound;
    },

    expensesGroups() {
      return this.$store.state.analyses.expensesGroups;
    },

    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    },

    isSmaller() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs" || name === "sm") return true;
      else return false;
    }
  }
};
</script>

<style scoped>
</style>
